import { useId } from 'react';
import { colors } from '../design-tokens/colors.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const DownloadIcon = ({
  color,
  fillPercentage,
  ...svgProps
}) => {
  const iconId = useId();
  const gradientId = `download-icon-${iconId.replace(/[^a-z0-9]/gi, "-")}-${fillPercentage ?? "default"}`;
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 22),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    strokeWidth: svgProps.strokeWidth ?? "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsxs("linearGradient", {
        id: gradientId,
        x1: "0%",
        x2: "0%",
        y1: "0%",
        y2: "100%",
        children: [/*#__PURE__*/jsx("stop", {
          offset: `${fillPercentage ?? 100}%`,
          stopColor: color ?? svgProps.stroke ?? "currentColor"
        }), typeof fillPercentage !== "undefined" && /*#__PURE__*/jsx("stop", {
          offset: `${fillPercentage ?? 100}%`,
          stopColor: colors.black(),
          stopOpacity: 0.2
        })]
      })
    }), /*#__PURE__*/jsx("path", {
      stroke: `url(#${gradientId})`,
      d: "M11 1v14.36M5.62 10.13 11 15.52l5.39-5.39M21 15.62v1.79c0 1.98-1.2 3.59-2.67 3.59H3.67C2.19 21 1 19.4 1 17.41v-1.8"
    })]
  });
};

export { DownloadIcon };
//# sourceMappingURL=download.js.map
